import React from 'react'
import classNames from 'classnames'

export interface Props {
  name?: string
  isSelected: boolean
  hasError?: boolean
  onClick: () => void
  className?: string
  children: React.ReactNode
}

export const RadioOptionBox: React.FC<Props> = ({
  name,
  onClick,
  isSelected,
  hasError = false,
  className,
  children,
}) => {
  return (
    <div
      className={classNames(
        {
          'rounded-lg border transition-all duration-200 ease-in-out': true,
          border: !isSelected,
          'ring-1': isSelected,
          'border-red ring-red': hasError,
          'border-core-gray-300': !isSelected && !hasError,
          'border-core-gray-900 ring-core-gray-900': isSelected && !hasError,
        },
        className
      )}
    >
      <div
        onClick={onClick}
        role="radio"
        aria-checked={isSelected}
        className="cursor-pointer flex w-full items-center rounded-lg text-left active:opacity-75 focus:outline-none"
      >
        <input type="hidden" name={name} />
        <div className="flex-1">{children}</div>

        <div
          className={classNames('mr-2 h-4 w-4 rounded-full border p-[2px]', {
            'border-core-gray-600': !isSelected && !hasError,
            'border-core-gray-900': isSelected && !hasError,
            'border-red': hasError,
          })}
        >
          {isSelected && (
            <div
              className={classNames('h-[10px] w-[10px] rounded-full', {
                'bg-red': hasError,
                'bg-core-gray-900': isSelected && !hasError,
              })}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default RadioOptionBox
